module.exports = __webpack_public_path__ + "static/media/SaveAway401kFull.9c1b6864.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Assets/SaveAway401kFull.png
// module id = 303
// module chunks = 0